"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageAsset = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var current_user_can_1 = require("../../utils/current-user-can");
var isNotSimple = function (_a) {
  var metadata = _a.metadata;
  return (metadata === null || metadata === void 0 ? void 0 : metadata.variant) !== 'simple';
};
exports.ImageAsset = {
  name: 'ImageAsset',
  label: 'Image',
  slug: 'image',
  autoRoutes: ['create', 'update', 'list'],
  canCreateInConversation: true,
  canEmbed: true,
  includeInSearch: true,
  valueImageStyle: 'banner',
  list: {
    resultsVariant: 'list',
    hasSearch: true
  },
  table: {
    fieldNames: ["info", "createdBy", "alternateText"]
  },
  form: {
    bufferAtEnd: 50,
    modal: {
      fill: true,
      maxWidth: "1200px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'breakpoints'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      image: {
        type: 'image',
        description: 'Upload or enter a URL to an Image',
        fieldSet: 'overview',
        required: true,
        maxPreviewWidth: 250
      },
      alternateText: {
        type: 'text',
        description: 'Provide alternate text describing this image for accessibility',
        fieldSet: 'overview',
        recommended: true
      },
      description: {
        type: 'textArea',
        isVisible: isNotSimple
      },
      imageInverted: {
        label: 'Image (Inverted)',
        isInverted: true,
        isVisible: isNotSimple,
        type: 'image',
        description: 'Upload or enter a URL to a version of this Image which is appropriate for a dark background, if needed.',
        fieldSet: 'overview',
        maxPreviewWidth: 250
      },
      portraitImage: {
        type: 'image',
        isVisible: isNotSimple,
        maxPreviewWidth: 250,
        fieldSet: 'breakpoints'
      },
      landscapeImage: {
        type: 'image',
        isVisible: isNotSimple,
        maxPreviewWidth: 250,
        fieldSet: 'breakpoints'
      },
      tabletImage: {
        type: 'image',
        isVisible: isNotSimple,
        maxPreviewWidth: 250,
        fieldSet: 'breakpoints'
      },
      largeImage: {
        type: 'image',
        isVisible: isNotSimple,
        maxPreviewWidth: 250,
        fieldSet: 'breakpoints'
      },
      sites: {
        type: 'linkedMultiple',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        },
        entityTypeName: 'Site',
        description: "Does this {{IMAGE_ASSET}} relate to any specific {{SITES}}? If not, leave this blank."
      }
    })
  },
  update: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      description { id text }\n      alternateText\n      image { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      portraitImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      landscapeImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      tabletImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      largeImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n    "], ["\n      description { id text }\n      alternateText\n      image { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      portraitImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      landscapeImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      tabletImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n      largeImage { id url formattedSize extension filename typeName thumbnails { id full { id url width height } } }\n    "])))
  }
};
var templateObject_1;